import(/* webpackMode: "eager", webpackExports: ["CTASection"] */ "/vercel/path0/book-generator/app/components/CTASection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/vercel/path0/book-generator/app/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Hero"] */ "/vercel/path0/book-generator/app/components/Hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Testimonials"] */ "/vercel/path0/book-generator/app/components/Testimonials.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ValueProposition"] */ "/vercel/path0/book-generator/app/components/ValueProposition.tsx");
